<template>
    <div class="tax-management">
      <!-- Header -->
     <AppHeader :title="`${productName} - Taxes`" />

  
      <!-- Add New Tax Button -->
      <button class="add-tax-btn" @click="addNewTax">Add New Tax</button>
  
      <!-- Table Structure -->
      <table id="taxTable">
        <thead>
          <tr>
            <!-- <th>ID</th> -->
            <th>Name</th>
            <th>Percentage (%)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tax in taxes" :key="tax.id">
            <!-- <td>{{ tax.id }}</td> -->
                         <td>{{ tax.name }}</td>
            <td>{{ tax.percentage }}</td>
            <td class="action-buttons">
              <button data-tooltip="Edit" @click="handleEdit(tax)">
                <img src="@/assets/edit_icon.png" alt="Edit">
              </button>
              <button data-tooltip="Delete" @click="handleDelete(tax)">
                <img src="@/assets/delete_icon.png" alt="Delete">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        taxes: [],
        currentDate: "",
        currentTime: "",
        token: null,
        productId: null,
        productName: ''
      };
    },
    mounted() {
      this.productId = this.$route.params.id;
      this.productName = this.$route.params.name;
      console.log(this.productName );
      this.token = localStorage.getItem('authToken');
      this.updateDateTime();
      setInterval(this.updateDateTime, 1000);
      this.fetchTaxes();
    },
    methods: {
      async fetchTaxes() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const response = await axios.get(
            `${this.$BASE_API_URL}/api/products/taxes/${this.productId}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
          );
  
          if (response.data.status) {
            this.taxes = response.data.data;
          }
        } catch (error) {
          console.error("Error fetching taxes:", error);
          this.$toast.error("Failed to load taxes. Please try again.");
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
  
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.currentTime = now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
  
      addNewTax() {
        if (!this.$hasPermission('create taxes')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ name: 'AddTaxProductComponent', params: { id: this.productId } });
      },
  
      handleEdit(tax) {
        if (!this.$hasPermission('edit taxes')){
        this.$toast.error('Not Permitted');
        return;
    }
        // Redirect to an edit form (implement as needed)
        this.$router.push({ name: "EditTaxProductComponent", params: { id: tax.id } });
      },
  
      async handleDelete(tax) {
        if (!this.$hasPermission('delete taxes')){
        this.$toast.error('Not Permitted');
        return;
    }
        if (confirm(`Delete tax ${tax.id} (${tax.percentage}%)?`)) {
          try {
            this.$root.isLoading = true; 
          this.loading = true;
            const response = await axios.delete(
              `${this.$BASE_API_URL}/api/taxes/${tax.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              }
            );
  
            if (response.data.error) {
              this.$toast.error("Failed to delete tax: " + (response.data.message || "Unknown error"));
            } else {
                this.fetchTaxes(); 
                this.$toast.success("Tax deleted successfully!");
            }
          } catch (error) {
            console.error("Error deleting tax:", error);
            this.$toast.error(error.response?.data?.message || "Deletion failed. Please try again.");
          }
          finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .tax-management {
    padding: 20px;
  }
  .add-tax-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: 0.5rem;
  }
  
  .action-buttons button {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;
    position: relative;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  
  .action-buttons button:hover {
    transform: scale(1.2);
    opacity: 0.8;
  }
  
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  
  /* Icon Colors */
  .action-buttons button[data-tooltip="Edit"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg); /* Green */
  }

  </style>